import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FiArrowLeft, FiSend, FiTrash2, FiEdit } from 'react-icons/fi';
import { FaRegCommentAlt } from 'react-icons/fa';
import { AiFillLike, AiOutlineLike } from 'react-icons/ai';
import api from '../../services/api';
import FeedLayout from '../Includes/FeedLayout';
import Perfil from '../../assests/avatar.png'
import { calculaTempo } from '../../global';
import { TextoComBandeiras, inserirBandeirasHtml } from '../../bandeiras';

import Linkify from 'linkifyjs/react';

import * as linkify from 'linkifyjs';
import hashtag from 'linkifyjs/plugins/hashtag';

import './styles.css';
import { useTranslation } from 'react-i18next';

hashtag(linkify);
export default function TimelineDetalhe(props) {
  const history = useHistory();
  const name = sessionStorage.getItem('name');
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const USER_ID = sessionStorage.getItem('id');
  const BASE_URL = sessionStorage.getItem('BASE_URL');

  const { t } = useTranslation();
  //const [det, setDet] = useState([]);
  // const [nome, setNome] = useState([]);
  // const [avatar, setAvatar] = useState([]);
  // const [tags, setTags] = useState([]);
  // const [firstCom, setFirstCom] = useState([]);
  // const [lastCom, setLastCom] = useState([]);
  let det = [];
  let nome = [];
  let avatar = [];
  let tags = [];
  let firstCom = [];
  let lastCom = [];
  let img = '';
  let file = [];
  const [text, setText] = useState('');
  const ID = parseInt(props.match.params.id);
  //let vPosts = JSON.parse(sessionStorage.getItem('sPosts'));
  const [vPosts, setVPosts] = useState(() => {
    try {
      const cached = JSON.parse(sessionStorage.getItem('sPosts'));
      return Array.isArray(cached) ? cached : [];
    } catch (err) {
      return [];
    }
  });
  const page = sessionStorage.getItem('page');
  const PARAMS = "";
  const [atualiza, setAtualiza] = useState('');
  const [evaluation, setEvaluation] = useState('');
  const [contaLike, setContaLike] = useState('');
  const [zoomImg, setZoomImg] = useState(null);

  useEffect(() => {
    const list = Array.isArray(vPosts) ? vPosts : [];
    if (list.some((item) => Number(item.id) === ID)) {
      return undefined;
    }

    let saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem('sPostDetalhe'));
    } catch (err) {
      saved = null;
    }
    if (saved && Number(saved.id) === ID) {
      setVPosts(list.concat([saved]));
      return undefined;
    }

    api.get(`/v6/posts/${ID}`, {
      headers: {
        USER_EMAIL,
        USER_TOKEN,
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      const data = response.data;
      const item = Array.isArray(data)
        ? data.find((post) => Number(post.id) === ID) || data[0]
        : data;
      if (item) {
        setVPosts((prev) => (Array.isArray(prev) ? prev : []).concat([item]));
      }
    }).catch(() => {});
    return undefined;
  }, [ID, USER_EMAIL, USER_TOKEN]);

  useEffect(() => {
    if (!zoomImg) return undefined;
    function onKey(e) {
      if (e.key === 'Escape') setZoomImg(null);
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [zoomImg]);
  // api.get(`/v4/posts?page=${page}&by_kind=feed`, {
  //   headers: {
  //     'USER_EMAIL': USER_EMAIL,
  //     'USER_TOKEN': USER_TOKEN,
  //     'PARAMS': PARAMS,
  //     'Content-Type': 'application/json'
  //   }
  // }).then(response => {
  //   setVPosts(JSON.stringify(response.data))
  //   sessionStorage.setItem('sPosts', JSON.stringify(response.data));
  // }).catch(err => {
  //   if (err.status === 401) {
  //     history.push('/');
  //   }
  // });

  async function enviarComentario(e) {
    e.preventDefault();
    if (text.length > 2) {
      const codComent = document.getElementById('codComent').value;
      if (codComent !== "") {
        var axios = require('axios');
        var data = JSON.stringify({ "text": text });

        var config = {
          method: 'put',
          url: BASE_URL + `/v4/posts/${ID}/comments/${codComent}`,
          headers: {
            'Content-Type': 'application/json',
            'USER_EMAIL': USER_EMAIL,
            'USER_TOKEN': USER_TOKEN
          },
          data: data
        };

        axios(config)
          .then(function (response) {
            api.get(`/v4/posts?page=${page}&by_kind=feed`, {
              headers: {
                'USER_EMAIL': USER_EMAIL,
                'USER_TOKEN': USER_TOKEN,
                'PARAMS': PARAMS,
                'Content-Type': 'application/json'
              }
            }).then(response => {
              //vPosts = JSON.stringify(response.data)
              setVPosts(response.data);
              document.getElementById('mensagem').value = "";
              document.getElementById('codComent').value = "";
            }).catch(err => {
              if (err.status === 401) {
                history.push('/');
              }
            });
          })
          .catch(function (error) {
          });
      } else {
        var axios = require('axios');
        var data = JSON.stringify({ "text": text });

        var config = {
          method: 'post',
          url: BASE_URL + `/v4/posts/${ID}/comments`,
          headers: {
            'Content-Type': 'application/json',
            'USER_EMAIL': USER_EMAIL,
            'USER_TOKEN': USER_TOKEN
          },
          data: data
        };

        axios(config)
          .then(function (response) {
            api.get(`/v4/posts?page=${page}&by_kind=feed`, {
              headers: {
                'USER_EMAIL': USER_EMAIL,
                'USER_TOKEN': USER_TOKEN,
                'PARAMS': PARAMS,
                'Content-Type': 'application/json'
              }
            }).then(response => {
              //vPosts = JSON.stringify(response.data)
              setVPosts(response.data);
              document.getElementById('mensagem').value = "";
            }).catch(err => {
              if (err.status === 401) {
                history.push('/');
              }
            });
          })
          .catch(function (error) {
            //history.go(0) 
          });
      }
    }
  }

  (Array.isArray(vPosts) ? vPosts : []).forEach((pItens) => {
    if (Number(pItens.id) === ID) {
      det = pItens;
      nome = pItens.user && pItens.user.name;
      avatar = (pItens.user && pItens.user.avatar) || {};
      tags = pItens.tags || [];
      firstCom = pItens.first_comments || [];
      lastCom = pItens.last_comments || [];
      file = pItens.file;
      if (!pItens.image) {
        img = null;
      } else {
        img = pItens.image.original;
      }
    }
  });

  var linkifyOptions = 
  {
      formatHref: function (href, type) {
        if (type === 'hashtag') {
          href = '#' + href.substring(1);
        }
        return href;
      }
    }
  function Description(props) {
    let texto = props.texto || '';
    const file = props.file;
    var regex = /(.*?:)/g;
    texto = texto.replace(regex, function(matched) {
      return `<b>${matched}</b>`
    });
    texto = inserirBandeirasHtml(texto);
    if(file){
        return (
          <>
          <Linkify options={linkifyOptions} >
            <p className="description" dangerouslySetInnerHTML={{ __html: texto }} />
          </Linkify>
          <p className="file"><a href={file} target="blank">{t('pages.timelineDetails.donwload')}</a></p>
          </>
          )
    }else{
      return (
        <Linkify options={linkifyOptions} >
          <p className="description" dangerouslySetInnerHTML={{ __html: texto }} />
        </Linkify>
        )
    }
  }

  function ImgScala(props) {
    if (!props.img || props.img === 'null') {
      return (<span></span>)
    }
    return (
      <img
        src={props.img}
        alt=""
        className="imgEscala"
        onClick={() => setZoomImg(props.img)}
      />
    )
  }

  function voltar() {
    history.goBack();
  }

  function ExcluiComent(props) {
    if (props.id == USER_ID) {
      return (
        <button id={props.id} onClick={() => apagaComent(props.comentCod)}><FiTrash2 /><span>{t('pages.timelineDetails.buttons.delete')}</span></button>
      )
    } else {
      return <span></span>
    }
  }

  function apagaComent(idComent) {
    var axios = require('axios');
    var config = {
      method: 'delete',
      url: BASE_URL + `/v4/posts/${ID}/comments/${idComent}`,
      headers: {
        'Content-Type': 'application/json',
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN
      }
    };

    axios(config)
      .then(function (response) {
        api.get(`/v4/posts?page=${page}&by_kind=feed`, {
          headers: {
            'USER_EMAIL': USER_EMAIL,
            'USER_TOKEN': USER_TOKEN,
            'PARAMS': PARAMS,
            'Content-Type': 'application/json'
          }
        }).then(response => {
          //vPosts = JSON.stringify(response.data)
          setVPosts(response.data);
          document.getElementById('mensagem').value = "";
          document.getElementById('codComent').value = "";

        }).catch(err => {
          if (err.status === 401) {
            history.push('/');
          }
        });
      })
      .catch(function (error) {
      });
  }

  // function Like(props) {
  //   return (
  //     <button onClick={() => curtir()}>
  //       <AiFillLike size={18} color="#DAD9E2" />
  //       <span className="like">{props.count}</span>
  //     </button>
  //   )
  // }
  function Like(props) {
    setEvaluation(props.evaluation);
    if (evaluation === true) {
      //evaluation = true;
      return (
        <button type="button">
          <AiFillLike size={18} color="#00b8ff" />
          <span className="like">{props.count}</span>
        </button>
      )
    } else {
      return (
        <button type="button" onClick={() => curtir(props.id, evaluation, props.count)}>
          <AiOutlineLike className="btn-like" size={18} color="#6b7280" />
          <span className="like">{props.count}</span>
        </button>
      )
    }
  }


  function AlteraComent(props) {

    if (props.id == USER_ID) {
      return (
        <button id={props.id} onClick={() => editComent(props.comentCod, props.texto)}><FiEdit /><span>{t('pages.timelineDetails.buttons.edit')}</span></button>
      )
    } else {
      return <span></span>
    }
  }
  function editComent(id, text) {
    document.getElementById('codComent').value = id;
    document.getElementById('mensagem').value = text;

  }

  function curtir(id, like, count) {
    var axios = require('axios');
    var data = JSON.stringify({ "evaluation": true });
    var config = {
      method: 'post',
      url: BASE_URL + `/v6/posts/${id}/evaluate`,
      headers: {
        'Content-Type': 'application/json',
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN
      },
      data: data
    };
    axios(config)
      .then(function (response) {
        setContaLike(parseInt(contaLike) + 1);
        //var atualizar = Math.floor(Math.random() * 65536);
        let conteudo = '<button type="button"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" size="18" color="#00b8ff" style="color: #00b8ff;" height="18" width="18" xmlns="http://www.w3.org/2000/svg"><path d="M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z"></path></svg><span class="like">';
        conteudo += (count + 1);
        conteudo +='</span></button>';
        var icones = document.getElementById('icones');
        icones.innerHTML = conteudo;
        
        //setAtualiza(atualizar);
      })
      .catch(function (error) {
      });

  }
  
  return (
    <FeedLayout active="timeline">
    <div className="timelineDet-container">
      <div className="feed-top">
        <button type="button" className="btn-voltar" onClick={voltar}>
          <FiArrowLeft size={18} /> {t('pages.timelineDetails.buttons.back')}
        </button>
        <span>{det.title ? <TextoComBandeiras texto={det.title} /> : t('pages.timeline.title.withoutHashTag')}</span>
      </div>
      <section className="body">
        <ul>
          <li >
            <p className="nomeProf"><img className="imgProf" src={(avatar && avatar.medium) ? avatar.medium : Perfil} alt="Perfil" /><span className="nome">{nome}</span><span className="tempo">  -  {calculaTempo(det.created_at)}</span></p>
            <p className="tags">
              { (tags || []).map(tag => (
                <span key={tag.id}>{tag.name}</span>
              ))
              }
            </p>
            <ImgScala img={img} />
            <Description texto={det.description || ''} file={file} />
            <p className="icons" id="icones">
              <Like count={det.ups_count} id={det.id} evaluation={det.evaluation} />
              <button>
                <span className="coment"><FaRegCommentAlt size={18} color="#6b7280" />
                  <span className="like">{parseInt((firstCom || []).length)}</span>
                </span>
              </button>
            </p>

            {
              (firstCom || []).map(com => (

                <div className="mensagens">
                  <p className="dadosPerfilComent"><img className="logoPerfilComent" src={(!com.user.avatar.mini_thumb) ? Perfil : com.user.avatar.mini_thumb} alt="img" /><span className="nomeComent">{com.user.name}</span><span className="dataComent"> - {calculaTempo(com.created_at)}</span></p>
                  <p className="textComent">{com.text}</p>
                  <div className="botoes">
                    <AlteraComent id={com.user.id} texto={com.text} comentCod={com.id} />
                    <ExcluiComent id={com.user.id} texto={com.text} comentCod={com.id} />
                  </div>
                </div>
              ))
            }

            {/* {
              lastCom.map(com2 => (
                <>
                <p>{com2.user.name}</p>
                <p>{com2.text}</p>
                </>
              ))
            } */}

            <form className="formComent" onSubmit={enviarComentario} id="formComent" >
              <div className="groupForm">
                <input id="codComent" type="hidden" />
                <input className="mensagem" type="text"
                  defaultValue={text} id="mensagem"
                  onChange={e => setText(e.target.value)}
                  placeholder={t('pages.timelineDetails.placeholders.message')}
                />
                <button type="submit" className="btn-send" aria-label="Enviar">
                  <FiSend className="iconSend" />
                </button>
              </div>
            </form>
          </li>
        </ul>
        <input type="hidden" value="true" id="evoluation" />
      </section>
      <section className="paginacao">
        <button type="button" className="btn-voltar" onClick={voltar}>
          <FiArrowLeft size={18} /> {t('pages.timelineDetails.buttons.back')}
        </button>
      </section>
      {zoomImg && (
        <div className="img-zoom" onClick={() => setZoomImg(null)} role="dialog" aria-modal="true">
          <button type="button" className="img-zoom-close" onClick={() => setZoomImg(null)} aria-label="Fechar">×</button>
          <img src={zoomImg} alt="" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
    </FeedLayout>
  )
}